import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { installMarketingTracker, trackMarketingEvent } from "@/lib/marketing";

export default function MarketingCapture() {
  const location = useLocation();

  useEffect(() => {
    installMarketingTracker();
  }, []);

  useEffect(() => {
    trackMarketingEvent("page_view", {
      surface: "dashboard",
      path: `${location.pathname}${location.search}`,
    });
  }, [location.pathname, location.search]);

  return null;
}
